import Vue from "vue";

Vue.config.productionTip = false;
const $P = {
    isLatin: document.body.classList.contains("latin"),
    isRtl: document.body.classList.contains("rtl"),
    __EVENT_CENTER: eventCenter,
    $emit: (...args) => {
        eventCenter.$emit(...args);
    },
    $on: (...args) => eventCenter.$on(...args),
    $once: (...args) => eventCenter.$once(...args),
    $off: (...args) => eventCenter.$off(...args)
};

const eventCenter = new Vue();
Vue.prototype.$P = $P;
